import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import { usePageMotion } from '../hooks/usePageMotion';
import './Projects.css';

const categories = [
  { id: 'all', label: 'Todos' },
  { id: 'web', label: 'Web' },
  { id: 'backend', label: 'Backend' },
  { id: 'automation', label: 'Automação' },
  { id: 'tools', label: 'Ferramentas' }
];

const Projects: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const root = usePageMotion<HTMLDivElement>(activeFilter);
  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(project => project.category === activeFilter);

  return (
    <div className="projects-page" ref={root}>
      <section className="projects-hero">
        <div className="container">
          <span className="eyebrow">PORTFÓLIO / PROJETOS</span>
          <h1 className="page-title">Código escrito.<br /><span>Problemas resolvidos.</span></h1>
          <p className="page-subtitle">Agendamentos, dados e automações. Veja o que construí e o problema que cada projeto precisou resolver.</p>
          <div className="projects-hero-bottom"><span>{String(projects.length).padStart(2, '0')} PROJETOS SELECIONADOS</span><span>DESENVOLVIMENTO & INTEGRAÇÕES <i className="fas fa-arrow-down" aria-hidden="true" /></span></div>
        </div>
      </section>

      <section className="projects-content" aria-label="Projetos do portfólio">
        <div className="container">
          <div className="project-toolbar">
            <div className="filter-buttons" role="group" aria-label="Filtrar projetos por categoria">
              {categories.map(category => <button key={category.id} type="button" className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`} onClick={() => setActiveFilter(category.id)} aria-pressed={activeFilter === category.id} aria-controls="project-results">{category.label}{category.id === 'all' && <span>{projects.length}</span>}</button>)}
            </div>
            <p className="project-count" role="status" aria-live="polite">{filteredProjects.length} {filteredProjects.length === 1 ? 'projeto' : 'projetos'}</p>
          </div>
          <div className="projects-grid" id="project-results">
            {filteredProjects.map(project => (
              <article key={project.id} className="project-card" data-reveal>
                <div className={`project-banner banner-${project.category}`} aria-hidden="true"><span>{project.label}</span><i className={`fas ${project.icon}`} /><span className="banner-category">{categories.find(category => category.id === project.category)?.label} / {String(projects.indexOf(project) + 1).padStart(2, '0')}</span></div>
                <div className="project-info">
                  <h2 className="project-title">{project.title}</h2>
                  <p className="project-description">{project.description}</p>
                  <div className="project-story"><div><strong>O desafio</strong><p>{project.challenge}</p></div><div className="project-outcome"><strong>A entrega</strong><p>{project.outcome}</p></div></div>
                  <div className="project-technologies">{project.technologies.map(tech => <span key={tech} className="tech-tag">{tech}</span>)}</div>
                  <div className="project-links">{project.liveUrl ? <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="project-link-btn">Visitar projeto <i className="fas fa-arrow-up-right-from-square" aria-hidden="true" /></a> : <span className="project-delivery"><i className="fas fa-check" aria-hidden="true" /> Projeto desenvolvido sob medida</span>}</div>
                </div>
              </article>
            ))}
          </div>
          <div className="projects-cta"><span className="eyebrow">PRÓXIMO PROJETO</span><h2>Tem algo parecido na sua rotina?</h2><p>Me conte como funciona hoje e o que você gostaria de mudar.</p><Link to="/contact" className="project-link-btn">Vamos conversar <i className="fas fa-arrow-right" aria-hidden="true" /></Link></div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
